module.exports = __webpack_public_path__ + "f7c61dd86552243ef1914444b417425b.png";